import { buildAxiosRequestConfig } from '@b-stock/fe-core/bstock-react'

import getAllListingsSearchClient from '@/queries/getAllListingsSearchClient'

const getSearchFilters = async ({
  accessToken,
  storeFrontId,
}: {
  accessToken: string | null
  storeFrontId?: string[]
}) => {
  const searchClient = getAllListingsSearchClient()
  const axiosParams = buildAxiosRequestConfig({ accessToken })
  const { data: filtersResponse } = await searchClient.allListingsFilters(
    { storeFrontId },
    axiosParams
  )

  return filtersResponse
}

export default getSearchFilters
